/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PermissionSet } from './PermissionSet';
import {
    PermissionSetFromJSON,
    PermissionSetFromJSONTyped,
    PermissionSetToJSON,
    PermissionSetToJSONTyped,
} from './PermissionSet';
import type { UserProfileDto } from './UserProfileDto';
import {
    UserProfileDtoFromJSON,
    UserProfileDtoFromJSONTyped,
    UserProfileDtoToJSON,
    UserProfileDtoToJSONTyped,
} from './UserProfileDto';
import type { TenantAccessDto } from './TenantAccessDto';
import {
    TenantAccessDtoFromJSON,
    TenantAccessDtoFromJSONTyped,
    TenantAccessDtoToJSON,
    TenantAccessDtoToJSONTyped,
} from './TenantAccessDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';
import type { PermissionData } from './PermissionData';
import {
    PermissionDataFromJSON,
    PermissionDataFromJSONTyped,
    PermissionDataToJSON,
    PermissionDataToJSONTyped,
} from './PermissionData';
import type { PermissionSummary } from './PermissionSummary';
import {
    PermissionSummaryFromJSON,
    PermissionSummaryFromJSONTyped,
    PermissionSummaryToJSON,
    PermissionSummaryToJSONTyped,
} from './PermissionSummary';

/**
 * 
 * @export
 * @interface MultiTenantSessionDto
 */
export interface MultiTenantSessionDto {
    /**
     * 
     * @type {string}
     * @memberof MultiTenantSessionDto
     */
    sessionId?: string;
    /**
     * 
     * @type {UserProfileDto}
     * @memberof MultiTenantSessionDto
     */
    profile?: UserProfileDto;
    /**
     * 
     * @type {TenantAccessDto}
     * @memberof MultiTenantSessionDto
     */
    currentTenant?: TenantAccessDto;
    /**
     * 
     * @type {Array<TenantAccessDto>}
     * @memberof MultiTenantSessionDto
     */
    availableTenants?: Array<TenantAccessDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MultiTenantSessionDto
     */
    selectedTenantIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MultiTenantSessionDto
     */
    selectableTenantIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MultiTenantSessionDto
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof MultiTenantSessionDto
     */
    updatedAt?: string;
    /**
     * 
     * @type {Date}
     * @memberof MultiTenantSessionDto
     */
    expiresAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof MultiTenantSessionDto
     */
    lastActivity?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MultiTenantSessionDto
     */
    metadata?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof MultiTenantSessionDto
     */
    isActive?: boolean;
    /**
     * 
     * @type {PermissionData}
     * @memberof MultiTenantSessionDto
     */
    currentTenantPermissions?: PermissionData;
    /**
     * 
     * @type {{ [key: string]: PermissionData; }}
     * @memberof MultiTenantSessionDto
     */
    crossTenantPermissions?: { [key: string]: PermissionData; };
    /**
     * 
     * @type {{ [key: string]: PermissionSet; }}
     * @memberof MultiTenantSessionDto
     */
    effectivePermissions?: { [key: string]: PermissionSet; };
    /**
     * 
     * @type {PermissionSummary}
     * @memberof MultiTenantSessionDto
     */
    permissionSummary?: PermissionSummary;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof MultiTenantSessionDto
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * 
     * @type {Array<string>}
     * @memberof MultiTenantSessionDto
     */
    accessibleFeatureIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MultiTenantSessionDto
     */
    upgradeCtaUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof MultiTenantSessionDto
     */
    upgradeCtaLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof MultiTenantSessionDto
     */
    upgradeCtaEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof MultiTenantSessionDto
     */
    marketplaceVisibility?: string;
    /**
     * When true, show the tenant picker after login.
     */
    requiresTenantSelection?: boolean;
    /**
     * When true, login domain has an explicit primary tenant binding.
     */
    explicitPrimaryBinding?: boolean;
    /**
     * Short-lived, Aegis-signed session access token. Must be sent as
     * `Authorization: Bearer <accessToken>` on every subsequent API request - a bare
     * X-Session-Id is not sufficient to authenticate (see AegisSessionTokenService).
     * @type {string}
     * @memberof MultiTenantSessionDto
     */
    accessToken?: string;
    /**
     * 
     * @type {Date}
     * @memberof MultiTenantSessionDto
     */
    accessTokenExpiresAt?: Date;
}

/**
 * Check if a given object implements the MultiTenantSessionDto interface.
 */
export function instanceOfMultiTenantSessionDto(value: object): value is MultiTenantSessionDto {
    return true;
}

export function MultiTenantSessionDtoFromJSON(json: any): MultiTenantSessionDto {
    return MultiTenantSessionDtoFromJSONTyped(json, false);
}

export function MultiTenantSessionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MultiTenantSessionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionId': json['session_id'] == null ? undefined : json['session_id'],
        'profile': json['profile'] == null ? undefined : UserProfileDtoFromJSON(json['profile']),
        'currentTenant': json['current_tenant'] == null ? undefined : TenantAccessDtoFromJSON(json['current_tenant']),
        'availableTenants': json['available_tenants'] == null ? undefined : ((json['available_tenants'] as Array<any>).map(TenantAccessDtoFromJSON)),
        'selectedTenantIds': json['selected_tenant_ids'] == null ? undefined : json['selected_tenant_ids'],
        'selectableTenantIds': json['selectable_tenant_ids'] == null ? undefined : json['selectable_tenant_ids'],
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'updatedAt': json['updated_at'] == null ? undefined : json['updated_at'],
        'expiresAt': json['expires_at'] == null ? undefined : (new Date(json['expires_at'])),
        'lastActivity': json['last_activity'] == null ? undefined : json['last_activity'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'currentTenantPermissions': json['current_tenant_permissions'] == null ? undefined : PermissionDataFromJSON(json['current_tenant_permissions']),
        'crossTenantPermissions': json['cross_tenant_permissions'] == null ? undefined : (mapValues(json['cross_tenant_permissions'], PermissionDataFromJSON)),
        'effectivePermissions': json['effective_permissions'] == null ? undefined : (mapValues(json['effective_permissions'], PermissionSetFromJSON)),
        'permissionSummary': json['permission_summary'] == null ? undefined : PermissionSummaryFromJSON(json['permission_summary']),
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'accessibleFeatureIds': json['accessibleFeatureIds'] == null ? undefined : json['accessibleFeatureIds'],
        'upgradeCtaUrl': json['upgradeCtaUrl'] == null ? undefined : json['upgradeCtaUrl'],
        'upgradeCtaLabel': json['upgradeCtaLabel'] == null ? undefined : json['upgradeCtaLabel'],
        'upgradeCtaEmail': json['upgradeCtaEmail'] == null ? undefined : json['upgradeCtaEmail'],
        'marketplaceVisibility': json['marketplaceVisibility'] == null ? undefined : json['marketplaceVisibility'],
        'requiresTenantSelection': json['requires_tenant_selection'] == null ? undefined : json['requires_tenant_selection'],
        'explicitPrimaryBinding': json['explicit_primary_binding'] == null ? undefined : json['explicit_primary_binding'],
        'accessToken': json['access_token'] == null ? undefined : json['access_token'],
        'accessTokenExpiresAt': json['access_token_expires_at'] == null ? undefined : (new Date(json['access_token_expires_at'])),
    };
}

export function MultiTenantSessionDtoToJSON(json: any): MultiTenantSessionDto {
    return MultiTenantSessionDtoToJSONTyped(json, false);
}

export function MultiTenantSessionDtoToJSONTyped(value?: MultiTenantSessionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'session_id': value['sessionId'],
        'profile': UserProfileDtoToJSON(value['profile']),
        'current_tenant': TenantAccessDtoToJSON(value['currentTenant']),
        'available_tenants': value['availableTenants'] == null ? undefined : ((value['availableTenants'] as Array<any>).map(TenantAccessDtoToJSON)),
        'selected_tenant_ids': value['selectedTenantIds'],
        'selectable_tenant_ids': value['selectableTenantIds'],
        'created_at': value['createdAt'],
        'updated_at': value['updatedAt'],
        'expires_at': value['expiresAt'] == null ? undefined : ((value['expiresAt']).toISOString()),
        'last_activity': value['lastActivity'],
        'metadata': value['metadata'],
        'is_active': value['isActive'],
        'current_tenant_permissions': PermissionDataToJSON(value['currentTenantPermissions']),
        'cross_tenant_permissions': value['crossTenantPermissions'] == null ? undefined : (mapValues(value['crossTenantPermissions'], PermissionDataToJSON)),
        'effective_permissions': value['effectivePermissions'] == null ? undefined : (mapValues(value['effectivePermissions'], PermissionSetToJSON)),
        'permission_summary': PermissionSummaryToJSON(value['permissionSummary']),
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'accessibleFeatureIds': value['accessibleFeatureIds'],
        'upgradeCtaUrl': value['upgradeCtaUrl'],
        'upgradeCtaLabel': value['upgradeCtaLabel'],
        'upgradeCtaEmail': value['upgradeCtaEmail'],
        'marketplaceVisibility': value['marketplaceVisibility'],
        'requires_tenant_selection': value['requiresTenantSelection'],
        'explicit_primary_binding': value['explicitPrimaryBinding'],
        'access_token': value['accessToken'],
        'access_token_expires_at': value['accessTokenExpiresAt'] == null ? undefined : ((value['accessTokenExpiresAt']).toISOString()),
    };
}

